<!--领队报名-->
<template>
  <div class="lingdui-report-container">
    <report-ld-dw
      :ssid="ssid"
      :isShowSsmc="isShowSsmc"
      :ssIsBm="'Y'"
    ></report-ld-dw>
    <loading-com />
  </div>
</template>

<script>
import ReportLdDw from "../commonCom/ReportLdDw.vue";
import LoadingCom from "../commonCom/LoadingCom.vue";
export default {
  name: "LingDuiReport",
  components: { ReportLdDw, LoadingCom },
  data() {
    return {
      isShowSsmc: true
    };
  },
  created() {
    this.utilPost = this.$util.handler;
    this.ssid = this.$route.query.ssid;
  },
  mounted() {},
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 🎨 领队报名容器 */
.lingdui-report-container {
  min-height: 100vh;
  background: linear-gradient(180deg, #f5f7fa 0%, #ffffff 100%);
}

/* 🎨 按钮美化 */
.van-button--round {
  height: 40px;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(24, 95, 155, 0.2);
  transition: all 0.3s ease;
}

.van-button--round:active {
  transform: scale(0.95);
}

/* 🎨 卡片美化 */
.van-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(24, 95, 155, 0.1);
  margin: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/ReportXm/LingDuiReport.vue